// ==============================================
// HORIZONTAL CAROUSEL LOGIC
// Only handles the Click-to-Focus Modal
// ==============================================

document.addEventListener('DOMContentLoaded', () => {
    
    // --- PART 1: CAROUSEL VIDEO CLICK HANDLER ---
    
    const cards = document.querySelectorAll('.video-card');
    const focusContainer = document.getElementById('FocusContainer');
    const focusVideo = document.getElementById('FocusVideo');
    const closeButton = document.getElementById('CloseFocus');
    
    // Open the modal
    cards.forEach(card => {
        card.addEventListener('click', () => {
            
            const videoElement = card.querySelector('.carousel-video');
            const videoSrc = videoElement.dataset.src;
            
            // Set the source and show the modal
            focusVideo.src = videoSrc;
            focusContainer.classList.add('is-visible');
            
            // Attempt to play the video
            focusVideo.play().catch(error => {
                 console.error("Autoplay failed:", error);
                 // If autoplay fails (common on mobile), it will rely on user interaction (controls)
            });
        });
    });

    // --- PART 2: CLOSE MODAL HANDLER ---
    
    const closeFocusModal = () => {
        focusContainer.classList.remove('is-visible');
        focusVideo.pause();
        focusVideo.src = ""; // Clear the source to release memory
    };

    closeButton.addEventListener('click', closeFocusModal);
    
    // Close if user clicks the semi-transparent background
    focusContainer.addEventListener('click', (e) => {
        if (e.target === focusContainer) {
            closeFocusModal();
        }
    });
});